import timeParse from 'date-fns/parse'
import differenceInCalendarDays from 'date-fns/difference_in_calendar_days'
import addDays from 'date-fns/add_days'
import format from 'date-fns/format'

export class AddBlankDay {
  static addBlankDay({ data, start, end }) {
    const blankCalender = this.createBlankCalender({ start, end })
    return blankCalender.map(blank => {
      const targetItem = data.find(item => {
        return item.reportDate === blank.reportDate
      })
      if (targetItem) {
        return { ...targetItem }
      }

      return blank
    })
  }
  static createBlankCalender({ start, end }) {
    const startDayObject = timeParse(start)
    const endDayObject = timeParse(end)
    // start end の間に何日あるのかレングスを出す
    const dayLength = differenceInCalendarDays(endDayObject, startDayObject) + 1

    // そのレングスから配列を作って
    const emptyArray = Array.from({ length: dayLength })

    // 配列に処理してカレンダーを作る
    return emptyArray.map((o, index) => {
      const dayObject = addDays(startDayObject, index)
      const day = format(dayObject, 'YYYY-MM-DD')
      return {
        reportDate: `${day}`,
      }
    })
  }
}

export const addBlankDay = ({ data, start, end }) =>
  AddBlankDay.addBlankDay({ data, start, end })
